import i18n from "i18next";
import {initReactI18next } from "react-i18next";
import translationEN from './TranslationEN.json';
import translationFR from './TranslationFR.json';
import translationNL from './TranslationNL.json';

const resources = {
    en: {
        translation: translationEN
    },
    nl: {
      translation: translationNL
    },
    fr: {
        translation: translationFR
    }
};

i18n
  .use(initReactI18next) 
  .init({    
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false 
    }
  });
  
export default i18n;
